<script>

	/* IMPORT: SVELTE/KIT */
	import { onMount, tick } from 'svelte';
	import { page } from '$app/stores';
	import { scale } from 'svelte/transition';
	import { quintOut } from 'svelte/easing';
  
	/* IMPORT: 3RD-PARTY */
	
	/* IMPORT: CUSTOM JS */
	import { storeDevice } from '$lib/script/store.js';
	import { storeShopifyCart } from '$lib/script/store.js';
	import Logo from '$lib/component/element/logo.svelte';
	import Link from '$lib/component/element/link.svelte';
	import Button from '$lib/component/element/button.svelte';

	import { navMainToggleInit,navMainSubMenuToggleInit } from '$lib/script/nav.js';

	let navMainToggle = null;
	let navMainMenu = null;

	/* Svelte Methods */
	$: navMainToggle && navMainMenu && navMainToggleInit( navMainToggle, navMainMenu, $storeDevice )
	$: navMainToggle && navMainMenu && navMainSubMenuToggleInit( navMainToggle, navMainMenu, $storeDevice );

	onMount( async () => 
	{
		// WAIT
		// await tick();

	});
</script>

<!-- A11y Skip Link -->
<a href='#main' name='main-anchor' style='display:none; visibility:invisible;'>Skip to main content</a>

<header data-id='HuqGJq' class='grid grid-max-0 sm:[border-left:8px_solid_var(--clr-white-static)] sm:[border-right:8px_solid_transparent] xxxl:[border-left:8px_solid_var(--clr-white-static)]'>
	<nav aria-label='Navigation Toggle' data-id='HuqGJq-toggle' bind:this={ navMainToggle }>
		<Button aria-label='Navigation Toggle' class='unstyled'>
			<span data-id='HuqGJq-open'>
				<svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
					<rect width="18" height="3" fill="#7E7E7E"/>
					<rect y="6" width="18" height="3" fill="#7E7E7E"/>
					<rect y="12" width="18" height="3" fill="#7E7E7E"/>
				</svg>	
			</span>
			<span data-id='HuqGJq-close'>
				<svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
					<rect x="0.575195" y="12.8032" width="18" height="3" transform="rotate(-45 0.575195 12.8032)" fill="#7E7E7E"/>
					<rect x="2.69678" y="0.0751953" width="18" height="3" transform="rotate(45 2.69678 0.0751953)" fill="#7E7E7E"/>
				</svg>	
			</span>
		</Button>
	</nav>
	<nav aria-label='Navigation Log Link' data-id='HuqGJq-logo'>
		<Link href='/' title='zMax&reg; Micro-Lubricant'>
			<Logo />
		</Link>
	</nav>
	<nav aria-label='Navigation Main' data-id='HuqGJq-main'>
		<menu bind:this={ navMainMenu } data-id='HuqGJq-main-menu'>
			<li><Link href='/'>
				<Button aria-label='Home'>
					<span data-id='HuqGJq-main-menu-label'>Home</span>
				</Button>
			</Link></li>
			<li>
				<Button aria-label='About'>
					<span data-id='HuqGJq-main-menu-label'>About</span>
					<span data-id='HuqGJq-main-menu-icon'>+</span>
				</Button>
				<menu data-id='HuqGJq-main-sub-menu'>
					<li><Link href='/about/' title='About zMax'>
						About zMax
					</Link></li>
					<li><Link href='/about/how-zmax-works/' title='How zMax Works'>
						How ZMax Works
					</Link></li>
					<li><Link href='/about/history/' title='History'>
						History
					</Link></li>
					<li><Link href='/about/testing/' title='Testing'>
						Testing
					</Link></li>
					<li><Link href='/about/videos/' title='Videos'>
						Videos
					</Link></li>
					<li><Link href='/about/customer-stories/' title='Customer Stories'>
						Customer Stories
					</Link></li>
					<li><Link href='/about/for-locomotives/' title='For Locomotives'>
						For Locomotives
					</Link></li>
					<li><Link href='/about/specials-and-events/' title='Specials and Events'>
						Specials and Events
					</Link></li>
				</menu>
			</li>
			<li><Button aria-label='Shop'>
					<span data-id='HuqGJq-main-menu-label'>Shop</span>
					<span data-id='HuqGJq-main-menu-icon'>+</span>
				</Button>
				<menu data-id='HuqGJq-main-sub-menu'>
					<li><Link href='https://shopify.zmax.com/collections/automotive/' title='Automotive'>
						Automotive
					</Link></li>
					<li><Link href='https://shopify.zmax.com/collections/firearms/' title='Fireamrs'>
						Firearms
					</Link></li>
					<li><Link href='https://shopify.zmax.com/collections/heavy-duty/' title='HEavy Duty'>
						Heavy Duty
					</Link></li>
					<li><Link href='https://shopify.zmax.com/collections/small-engine/' title='Small Engines'>
						Small Engine
					</Link></li>
					<li><Link href='https://shopify.zmax.com/collections/aviation/' title='Aviation'>
						Aviation
					</Link></li>
					<li><Link href='https://shopify.zmax.com/collections/aerosols-appearance/' title='Aerosols / Appearance'>
						Aerosols / Appearance
					</Link></li>
					<li><Link href='https://shopify.zmax.com/collections/racing-oil/' title='Racing Oil'>
						Racing Oil
					</Link></li><li><Link href='https://shopify.zmax.com/collections/power-sports/' title='Power Sports'>
						Power Sports
					</Link></li>
					<li><Link href='https://shopify.zmax.com/collections/apparel/' title='Apparel'>
						Apparel
					</Link></li>
				</menu>
			</li>
			<li><Link href='/find-a-store'>
				<Button aria-label='Find A Store'>
					<span data-id='HuqGJq-main-menu-label'>Find A Store</span>
				</Button>
			</Link></li>
			<li><Link href='/faqs'>
				<Button aria-label='FAQs'>
					<span data-id='HuqGJq-main-menu-label'>FAQs</span>
				</Button>
			</Link></li>
			<li><Link href='/contact-us/' title='Contact Us'>
				<Button aria-label='Contact'>
					<span data-id='HuqGJq-main-menu-label'>Contact</span>
				</Button>
			</Link></li>
		</menu>
	</nav>
	
	<nav aria-label='Navigation Shopify' data-id='HuqGJq_shopify'>
		<menu data-id='HuqGJq-main-shopify' class='flex flex-row flex-auto gap-[8px] my-[8px]'>
			<li class='h-[100%]'><Link href='https://store.zmax.com/account/login' title='zMax&reg; Shop: My Account' class='HuqGJq-main-link flex flex-auto unstyled'>
				<Button aria-label='zMax&reg; Shop: My Account' class='HuqGJq-shopify-button unstyled xxl:bg-black xxl:text-white flex flex-row flex-auto max-sm:w-[24px] max-sm:h-[24px]  sm:max-xxl:pr-[16px] xxl:px-[24px] !py-[23px]'>
					<span class='HuqGJq-shopify-text mr-[8px] max-xxl:hidden'>My Account</span>
					<svg class='HuqGJq-shopify-profile' width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path class='max-xxl:fill-[#000]' d="M7.49941 10.151C4.6089 10.151 2.25488 7.87285 2.25488 5.0755C2.25488 2.27815 4.6089 0 7.49941 0C10.3899 0 12.7439 2.27815 12.7439 5.0755C12.7439 7.87285 10.3899 10.151 7.49941 10.151ZM7.49941 1.44636C5.43554 1.44636 3.75488 3.07285 3.75488 5.0702C3.75488 7.06755 5.43554 8.69404 7.49941 8.69404C9.56328 8.69404 11.2439 7.06755 11.2439 5.0702C11.2439 3.07285 9.56328 1.44636 7.49941 1.44636Z" fill="white"/>
						<path class='max-xxl:fill-[#000]' d="M14.9939 15.9523H13.4939C13.4939 12.7523 10.806 10.151 7.49941 10.151C4.19284 10.151 1.50488 12.7523 1.50488 15.9523H0.00488281C0.00488281 11.9523 3.3662 8.69934 7.49941 8.69934C11.6326 8.69934 14.9939 11.9523 14.9939 15.9523Z" fill="white"/>
					</svg>
				</Button>
			</Link></li>
			<li class='inline-block'><Link href='https://store.zmax.com/cart/' title='zMax&reg; Shop: My Cart' class='HuqGJq-main-link unstyled'>
				<Button aria-label='zMax&reg; Shop: My Cart'  class='HuqGJq-shopify-button unstyled xxl:bg-grey-dark flex flex-row flex-auto max-xxl:pr-[16px] xxl:px-[24px] !py-[23px]'>
					<span class='HuqGJq-shopify-text mr-[8px] max-xxl:hidden'>View Cart</span>
					<svg class='HuqGJq-shopify-cart' width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M17.9609 5.34147L15.8674 11.935C15.7109 12.4045 15.3 12.7176 14.8109 12.7176H6.73043C6.26087 12.7176 5.81087 12.4241 5.65435 11.9936L2.56304 3.71756H0.782609C0.352174 3.71756 0 3.36539 0 2.93495C0 2.50452 0.352174 2.15234 0.782609 2.15234H3.11087C3.44348 2.15234 3.73696 2.36756 3.85435 2.6806L7.04348 11.1523H14.4783L16.1413 5.86974H6.92609C6.49565 5.86974 6.14348 5.51756 6.14348 5.08713C6.14348 4.65669 6.49565 4.30452 6.92609 4.30452H17.2174C17.4717 4.30452 17.7065 4.44147 17.8435 4.63713C18 4.83278 18.0391 5.10669 17.9609 5.34147ZM7.12174 13.7545C6.78913 13.7545 6.45652 13.8915 6.22174 14.1263C5.98696 14.361 5.85 14.6936 5.85 15.0263C5.85 15.3589 5.98696 15.6915 6.22174 15.9263C6.45652 16.161 6.78913 16.298 7.12174 16.298C7.45435 16.298 7.78696 16.161 8.02174 15.9263C8.25652 15.6915 8.39348 15.3589 8.39348 15.0263C8.39348 14.6936 8.25652 14.361 8.02174 14.1263C7.78696 13.8915 7.45435 13.7545 7.12174 13.7545ZM14.1457 13.7545C13.813 13.7545 13.4804 13.8915 13.2457 14.1263C13.0109 14.361 12.8739 14.6936 12.8739 15.0263C12.8739 15.3589 13.0109 15.6915 13.2457 15.9263C13.4804 16.161 13.813 16.298 14.1457 16.298C14.4783 16.298 14.8109 16.161 15.0457 15.9263C15.2804 15.6915 15.4174 15.3589 15.4174 15.0263C15.4174 14.6936 15.2804 14.361 15.0457 14.1263C14.8109 13.8915 14.4783 13.7545 14.1457 13.7545Z" fill="black"/>
					</svg>	
					{#if $storeShopifyCart?.item_count }<span class='HuqGJq-shopify-cart-notification' transition:scale={{ duration: 1500, delay: 250, opacity: 0, start: 0, easing: quintOut }}>{ ( $storeShopifyCart?.item_count ) ? `${ $storeShopifyCart?.item_count }` : `` }</span>{/if}
				</Button>
			</Link></li>
		</menu>
	</nav>
</header>

<style lang='scss'>

	/*
	 * ----------------------------------------------------------------
		Table of Contents
	 * ----------------------------------------------------------------
    - MQ/Props
 	 - Header
 	 - Nav Logo
	 - Nav Toggle
	 - Nav Main Expanded & Scroll
	 - Nav Main
	 - Nav Sub-Main
	 - Menu Shopify
	*/

	:root {

		--pUKZp7-brand-blockquote-margin-bottom-xxxl: #{XXXLMin(116px, 116px)};
	}
	
	:where( [data-id=HuqGJq] )
	{
		--HuqGJq-top: 0px;
		--HuqGJq-max-height: 80px;
		
	}
	

	@media screen and (min-width: theme('screens.md'))
	{
		
	}

		// HuqGJq-shopify-profile-fill
	@media screen and (min-width: theme('screens.sm'))
	{
		:where( [data-id=HuqGJq] )
		{
			--HuqGJq-top: 16px;
		}
	}

	@media screen and (min-width: theme('screens.xxl'))
	{
		:where( [data-id=HuqGJq] )
		{
			--HuqGJq-position: relative;
			
			--HuqGJq-toggle-position: initial;
			--HuqGJq-toggle-zindex: initial;
			--HuqGJq-toggle-display: none;
			
			--HuqGJq-logo-left: 26px;
			--HuqGJq-logo-place-self: center start;

			--HuqGJq-main-overflow: visible;
			--HuqGJq-main-position: relative;
			--HuqGJq-main-display: grid;
			--HuqGJq-main-place-self: center start;
			--HuqGJq-main-width: auto;
			--HuqGJq-main-height: 100%;
			--HuqGJq-main-top: 0px;
			--HuqGJq-main-left: min( #{XXXL(748px)}, 748px);
			--HuqGJq-bg-color: transparent;

			--HuqGJq-main-menu-display: flex;
			--HuqGJq-main-menu-height: 100%;
			--HuqGJq-main-menu-flex-direction: row;
			--HuqGJq-main-menu-flex-min-width: auto;

			--HuqGJq-main-menu-a-font-family: 'Gilroy-Semibold', sans-serif;
			--HuqGJq-main-menu-a-font-size: 16px;// min( #{XXXL(20px)}, 20px);
			--HuqGJq-main-menu-a-line-height: 1;
			--HuqGJq-main-menu-a-font-weight: 400;

			--HuqGJq-main-menu-a-button-min-width: auto;
			--HuqGJq-main-menu-a-button-icon-position: relative;


			--HuqGJq-main-sub-menu-position: absolute;
			--HuqGJq-main-sub-menu-display: none;
			--HuqGJq-main-sub-menu-left: -35%;
			--HuqGJq-main-sub-menu-margin-start: 78px;
			--HuqGJq-main-sub-menu-margin-end: 0px;
			--HuqGJq-main-sub-menu-padding-block-start: 10px;
			--HuqGJq-main-sub-menu-padding-block-end: 20px;
			--HuqGJq-main-sub-menu-padding-inline-start: 24px;
			--HuqGJq-main-sub-menu-padding-inline-end: 24px;
			--HuqGJq-main-sub-menu-width: max-content;
			--HuqGJq-main-sub-menu-border: none;
			--HuqGJq-main-sub-menu-background-color: var(--clr-gray-light-static);
			--HuqGJq-main-sub-menu-filter: drop-shadow(0px 8px 4px rgba(0,0,0,.15));


			--HuqGJq-main-sub-menu-li-margin-start: 8px;

			--HuqGJq-main-sub-menu-a-text-align: left;
		}
	}

	/*
	 * ----------------------------------------------------------------
		Header
	 * ----------------------------------------------------------------
	*/

	:where( [data-id=HuqGJq] ) 
	{
		z-index: 100;
		position: var(--HuqGJq-position, relative);
		margin-block-start: var(--HuqGJq-top);
		height: var(--HuqGJq-max-height);
		max-height: var(--HuqGJq-max-height);
		background-color: var(--clr-gray-light-static);
	}

	:where( [data-id=HuqGJq] ) > *
	{
		z-index: 1;
		grid-column: 1/-1;
		grid-row: 1/-1;
	}



	/*
	 * ----------------------------------------------------------------
		Nav Logo
	 * ----------------------------------------------------------------
	*/

	:where( [data-id=HuqGJq-logo] ) 
	{
		max-width: 132px;
		left: var(--HuqGJq-logo-left, 0);
		place-self: var(--HuqGJq-logo-place-self, center);
	}



	/*
	 * ----------------------------------------------------------------
		Nav Toggle
	 * ----------------------------------------------------------------
	*/

	:where( [data-id=HuqGJq-toggle] )
	{
		z-index: 10000;
		display: var(--HuqGJq-toggle-display, grid);
		width: 61px;
		height: 61px;
		background-color: var(--clr-gray-medium-static);
		place-content: center;
		place-self: center start;
		margin-inline-start: 8px;
		cursor: pointer;
	}

	:global( :where( [data-id=HuqGJq-toggle] ) [data-id=eyCT2h] )
	{
		min-width: auto;
	}

	:where( [data-id=HuqGJq-toggle]:not( .active ) ) [data-id=HuqGJq-close] 
	{
		display: none;
	}

	:where( [data-id=HuqGJq-toggle].active ) [data-id=HuqGJq-open] 
	{
		display: none;
	}

  

	/*
	 * ----------------------------------------------------------------
		Main Nav Expanded & Scroll
	 * ----------------------------------------------------------------
	*/

	:global( :where( html[data-nav-main-expanded=true] ) ) { overflow: hidden; }
	:global( :where( html[data-nav-main-expanded=true] ) [data-id=HuqGJq-main] ) { overflow-y: scroll; overflow-x: hidden; }


	/*
	 * ----------------------------------------------------------------
		Mav Main
	 * ----------------------------------------------------------------
	*/

	:where( [data-id=HuqGJq-main] ) 
	{
		place-self: var(--HuqGJq-main-place-self, start end);
		position: var(--HuqGJq-main-position, fixed );	
		display: var(--HuqGJq-main-display, none );	
		width: var(--HuqGJq-main-width, calc( 104vw ));
		height: var(--HuqGJq-main-height, calc( 104vh - var(--HuqGJq-max-height) ) );
		background-color: var(--HuqGJq-bg-color, var(--clr-white-static));
		top: var(--HuqGJq-main-top, calc( var(--HuqGJq-max-height) + var(--HuqGJq-top) ));
		left: var(--HuqGJq-main-left, 0);
	}

	:where( [data-id=HuqGJq-toggle]:not( .active ) ) ~ [data-id=HuqGJq-main] 
	{
		display: var(--HuqGJq-main-display, none );
	}

	:where( [data-id=HuqGJq-toggle].active ) ~ [data-id=HuqGJq-main] 
	{
		display: grid;
	}

	/* Handle pad non-desktop menu */
	:where( html[data-nav-main-expanded=true]:not( [data-device-sized=desktop] )  [data-id=HuqGJq-toggle].active ) ~ [data-id=HuqGJq-main] 
	{
		padding-block: 48px calc( 24px + var(--HuqGJq-max-height) );
	}


	:where( [data-id=HuqGJq-main-menu] )
	{
		display: var(--HuqGJq-main-menu-display, grid);
		flex-direction: var(--HuqGJq-main-menu-flex-direction, column);
		place-self: center center;
		column-gap: min( #{XXXL(50px)}, 50px);
		min-width: var(--HuqGJq-main-menu-flex-min-width, min( #{XS(398px)}, 398px));
		height: var(--HuqGJq-main-menu-height, auto);
	}

	:where( [data-id=HuqGJq-main-menu] ) li
	{
		display: grid;
	}

	:where( [data-id=HuqGJq-main-menu] ) :global( a )
	{
		--link-clr: var(--clr-black-static);
		--link-clr-hover: var(--clr-red-static);
		--link-text-decoration: none;

		display: grid;
		grid-template-columns: auto;
		width: 100%;
		text-decoration: none;
	}

	:global( [data-id=HuqGJq-main-menu] button ),
	:global( [data-id=HuqGJq-main-menu] button:hover )
	{
		--btn-min-width: auto;
		background-color: transparent;
		padding: 0;
		border: 0;
		margin: 0;
	}

	:global( :where( [data-id=HuqGJq-main-menu] ) ) span 
	{
		font-family: var(--HuqGJq-main-menu-a-font-family, inherit);
		font-size: var(--HuqGJq-main-menu-a-font-size, var(--font-size-40));
		font-weight: var(--HuqGJq-main-menu-a-font-weight, initial);
		letter-spacing: auto !important;
	}

	:where( [data-id=HuqGJq-main-menu] ) :where( [data-id=HuqGJq-main-menu-icon] )
	{
		position: var(--HuqGJq-main-menu-a-button-icon-position, absolute);
		right: 0;
	}


	/*
	 * ----------------------------------------------------------------
		Mav Sub-Main
	 * ----------------------------------------------------------------
	*/

	:where( [data-id=HuqGJq-main-menu] ) :where( [data-id=HuqGJq-main-sub-menu] )
	{
		position: var(--HuqGJq-main-sub-menu-position, initial);
		display: none;
		left: var(--HuqGJq-main-sub-menu-left, initial);
		margin-block-start: var(--HuqGJq-main-sub-menu-margin-start, 8px);
		margin-block-end: var(---HuqGJq-main-sub-menu-margin-end, 12px);
		padding-block-start: var(--HuqGJq-main-sub-menu-padding-block-start, 24px);
		padding-block-end: var(--HuqGJq-main-sub-menu-padding-block-end, 24px);
		padding-inline-start: var(--HuqGJq-main-sub-menu-padding-inline-start);
		padding-inline-end: var(--HuqGJq-main-sub-menu-padding-inline-end);
		border-top: var(--HuqGJq-main-sub-menu-border, 1px solid var(--clr-black-static));
		border-bottom: var(--HuqGJq-main-sub-menu-border, 1px solid var(--clr-black-static));
		width: var(--HuqGJq-main-sub-menu-width, 100%);
		place-self: start center;
		background-color: var(--HuqGJq-main-sub-menu-background-color, transparent);
		filter: var(--HuqGJq-main-sub-menu-filter, initial);
	
	}

	/* Desktop or Mouse */ 
	:global( :where( html[data-nav-main="desktop"] ) :where( [data-id=HuqGJq-main-menu] li:has( > menu ) ):hover ) [data-id=HuqGJq-main-sub-menu],
	/* Mobile or Touch and/or Touch Emulated */ 
	:global( :where( [data-id=HuqGJq-main-menu] ) li:has( > menu ).active [data-id=HuqGJq-main-sub-menu] )
	{
		display: grid;
	}

	:global( :where( [data-id=HuqGJq-main-sub-menu] li:not( :first-child ) )  )
	{
		margin-block-start:  var(--HuqGJq-main-sub-menu-li-margin-start, 8px);
	}

	:where( [data-id=HuqGJq-main-menu] ) :global( a )
	{
		text-align: var(--HuqGJq-main-sub-menu-a-text-align, center);
		text-transform: uppercase;
	}


	/*
	 * ----------------------------------------------------------------
		Nav Shopify
	 * ----------------------------------------------------------------
	*/

	:where( [data-id=HuqGJq_shopify] ) 
	{
		place-self: start end;
	}

	:where( .HuqGJq-shopify-cart-notification )
	{
		font-family: sans-serif;
		font-size: 10px;
		font-weight: bolder;
		background-color: red;
		border-radius: 1000px;
		// outline: 1px solid red;
		overflow:hidden;
		padding: 2px 0 2px;
		width: 17px;
		height: auto;
		color: var(--clr-white-static);
		top: -6px;
		left: -6px;
	}

</style>